module.exports = __webpack_public_path__ + "static/services_icon_1-f1e674dcd833a01cd485c1c634fa832f.svg";